import React, { useState } from 'react';
import '../styles/components/NevBar.scss';
//import Hamburger from "./Hamburger.tsx";

interface ErrorBadgeProps {
  numOfErrors: number
}

const ErrorCountBadge: React.FC<ErrorBadgeProps> = (props: ErrorBadgeProps) => {
  return (
    <div className="badge">{props.numOfErrors}</div>
  );
};

interface SidebarComponentProps {
  activePage: string,
  handlePageChange: (values: string) => void,
  isDisabled: boolean,
  userType: string
}

const Sidebar: React.FC<SidebarComponentProps> = (props: SidebarComponentProps) => {
  const {
    activePage,
    isDisabled,
    handlePageChange,
    userType
  } = props;

  /*const [hamburgerOpen, setHamburgerOpen] = useState(false);

  const toggleHamburger = () => {
    setHamburgerOpen(!hamburgerOpen)
  }*/

  function handlePageClick(pageName: string) {
    handlePageChange(pageName);
    //toggleHamburger();
  }

  return (
    <>

      <div className="nav">
        {isDisabled && <div className="blocker" />}
        
        {/*<img className="zachys-logo" src="/zachys-logo-black-text.jpg" onClick={() => handlePageChange("HOME")} />*/}
        <div className="nav">
          <div className="ul">
            <div className={`li a  ${activePage === 'FILE_UPLOADS' ? 'active-tab' : ''}`} onClick={() => handlePageClick("FILE_UPLOADS")} >
            Item Lookup
            </div>
            <div className={`li a ${activePage === 'FILE_UPLOADS_NS' ? 'active-tab' : ''}`} onClick={() => handlePageClick("FILE_UPLOADS_NS")} >
            Item Creation
            </div>
            <div className={`li a ${activePage === 'INSTRUCTIONS' ? 'active-tab' : ''}`} onClick={() => handlePageClick("INSTRUCTIONS")} >
            Instructions
            </div>
            <div className={`li a ${activePage === 'PRICING_INSTRUCTIONS' ? 'active-tab' : ''}`} onClick={() => handlePageClick("PRICING_INSTRUCTIONS")} >
            Pricing Instructions
            </div>
            <div className={`li a ${activePage === 'AUDIT_SEARCH_RESULT' ? 'active-tab' : ''}`} onClick={() => handlePageClick("AUDIT_SEARCH_RESULT")} >
            Audit Search Result
            </div>
          </div>
        </div>
      </div>
      




      {/*<div className="sidebar-container">
        {isDisabled && <div className="blocker" />}
        */}
        {/*<img className="zachys-logo" src="/zachys-logo-black-text.jpg" onClick={() => handlePageChange("HOME")} />*/}
        {/*<div className="sidebar-tabs">
          <div className="sidebar-tab">
            <div className={`sidebar-lead ${activePage === 'FILE_UPLOADS' ? 'active-tab' : ''}`} onClick={() => handlePageClick("FILE_UPLOADS")} >
              Upload Files
            </div>
            <div className={`sidebar-lead ${activePage === 'FILE_UPLOADS_NS' ? 'active-tab' : ''}`} onClick={() => handlePageClick("FILE_UPLOADS_NS")} >
              Upload File to NetSuite
            </div>
            <div className={`sidebar-lead ${activePage === 'AUDIT_SEARCH_RESULT' ? 'active-tab' : ''}`} onClick={() => handlePageClick("AUDIT_SEARCH_RESULT")} >
              Audit Search Result
            </div>
          </div>
        </div>
      </div>
      */}

      {/*<div className="hamburger" onClick={toggleHamburger}>
        <Hamburger isOpen={hamburgerOpen} />
      </div>*/}

      <style>{/*`
     .hamburger{
          float: left;
          display:flex;
          padding-top: 10px;
          z-index: 6;
      }

    .sidebar-container{
      display: ${hamburgerOpen ? 'inline' : 'none'};
    }
      .content-window{
        position: ${hamburgerOpen ? 'relative' : 'absolute'};
        }
  `*/}</style>
    </>
  );
}

export default Sidebar;
